var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHulu = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 22",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hulu_svg__clip0_6045_93147)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8F8",
  d: "M40.347 21.827h5.155V.191h-5.155zm-9.085-6.156c0 .774-.618 1.399-1.381 1.399h-3A1.39 1.39 0 0 1 25.5 15.67V6.942h-5.155v9.166c0 3.746 2.367 5.72 5.869 5.72h5.047c3.224 0 5.155-2.35 5.155-5.72V6.942h-5.155v8.73zm29.079-8.729v8.73c0 .773-.617 1.398-1.38 1.398h-3a1.39 1.39 0 0 1-1.38-1.399V6.942h-5.157v9.166c0 3.746 2.37 5.72 5.87 5.72h5.048c3.224 0 5.155-2.35 5.155-5.72V6.942zm-49.55 0H7.486c-1.16 0-1.743.318-1.743.318V.19H.59v21.636h5.153v-8.731c0-.772.62-1.398 1.382-1.398h2.999c.763 0 1.381.626 1.381 1.398v8.731h5.155V12.42c0-3.954-2.605-5.478-5.869-5.478"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hulu_svg__clip0_6045_93147"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.59.191h64.907v21.636H.59z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHulu);
export default ForwardRef;